import React from "react";
import { Row, Col } from 'react-bootstrap';
import { useNavigate}  from 'react-router-dom';
import { useTheme } from '../../../../Hooks';
import { AnimatedIconButton } from '../../../AnimatedIconButton/AnimatedIconButton';
function LeftSectionHeader(props) {
    const { theme } = useTheme();
    const navigate = useNavigate();
    function goBack() {
        navigate(-1);
    }

    return (
        <div
            className="mt-2"
            style={{
                backgroundColor: "transparent",
                borderTop: "3px solid",
                borderBottom: "3px solid",
                borderTopColor: theme.color1,
                borderBottomColor: theme.color1,
                padding: "0px !important",
            }}
        >
            <Row>
                <Col md={6} className={"d-flex justify-content-start"}>
                    <div
                        className="ml-5"
                        style={{ marginRight: "65%", position: "relative" }}
                    >
                        <div
                            style={{
                                position: "absolute",
                                top: "-1vh",
                                left: "-1vw",
                            }}
                        >
                            <AnimatedIconButton
                                onClick={props.backFunc ? props.backFunc : goBack}
                                style={{
                                    marginTop: "-0.4px",
                                }}
                                size="50px"
                                height="35px"
                                width="35px"
                                message="Volver"
                                iconName="back"
                                isWhite={true}
                            />
                        </div>
                    </div>
                </Col>
                <Col md={6} className={"d-flex justify-content-end"}>
                    <h5
                        style={{
                            color: "#77777a",
                            fontSize: "2.5vh",
                            marginTop: "0.2vh",
                            marginBottom: "0.2vh",
                            marginRight: "10%",
                        }}
                    >
                        {props.label}
                    </h5>
                </Col>
            </Row>
        </div>
    );
}
export default LeftSectionHeader